module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "landing-words landing-words-details"
  }, [_c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }]
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "text-center headline-container container-fluid"
  }, [_c('h1', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "headline"
  }, [_vm._v("Insights, commentary and news")])])])]), _vm._v(" "), _c('section', {
    staticClass: "content-article"
  }, [_c('div', {
    staticClass: "inside"
  }, [(_vm.pageData.elements) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "content-article-body col-lg-9 col-sm-8 col-xs-12"
  }, [_c('h4', {
    staticClass: "type-name"
  }, [_vm._v(_vm._s(_vm.pageData.elements.word_category.value[0].name))]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.pageData.elements.header_title.value))]), _vm._v(" "), _c('small', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.pageData.elements.date.value, "add", "1 days", "MMMM Do YYYY")))]), _vm._v(" "), (_vm.pageData.elements.vimeo_id.value.length) ? _c('div', {
    staticClass: "embed-container"
  }, [_c('iframe', {
    attrs: {
      "src": 'https://player.vimeo.com/video/' + _vm.pageData.elements.vimeo_id.value + '?loop=1&title=0&byline=0&portrait=0&api=1&muted=1&autoplay=1',
      "width": "640",
      "height": "360",
      "frameborder": "0",
      "allow": "autoplay; fullscreen",
      "allowfullscreen": ""
    }
  })]) : (_vm.pageData.elements.thumbnail_image.value.length) ? _c('div', {
    staticClass: "mask-image"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.pageData.elements.thumbnail_image.value[0].url),
      expression: "pageData.elements.thumbnail_image.value[0].url"
    }],
    attrs: {
      "alt": _vm.pageData.elements.thumbnail_image.value[0].name
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.pageData.elements.main_content.value)
    }
  })]), _vm._v(" "), (_vm.authorData.elements) ? _c('div', {
    staticClass: "content-article-author text-center col-lg-3 col-sm-4 col-xs-12"
  }, [(_vm.authorData.elements.image.value.length) ? _c('div', {
    staticClass: "mask-image img-responsive",
    style: (_vm.setBackgroundImage(_vm.authorData.elements.image.value[0].url))
  }) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "author-name"
  }, [_vm._v(_vm._s(_vm.authorData.elements.name.value))]), _vm._v(" "), _c('h5', {
    staticClass: "author-position"
  }, [_vm._v(_vm._s(_vm.authorData.elements.position.value))]), _vm._v(" "), _c('div', {
    staticClass: "author-description",
    domProps: {
      "innerHTML": _vm._s(_vm.authorData.elements.bio.value)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "related_articles"
  }, [_c('h3', [_vm._v("OTHER ARTICLES BY THIS AUTHOR")]), _vm._v(" "), _c('ul', _vm._l((_vm.relatedArticles), function(art) {
    return _c('li', [_c('a', {
      attrs: {
        "href": art.elements.url.value
      }
    }, [_vm._v(_vm._s(art.elements.header_title.value))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "newsletter"
  }, [_c('h3', [_vm._v("SIGN UP FOR OUR NEWSLETTER")]), _vm._v(" "), _c('newsletter')], 1)]) : _vm._e()]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-387f128a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/landings/Article.vue
// module id = 1514
// module chunks = 0